import { render } from "./UiZoomImg.vue?vue&type=template&id=42b03333&scoped=true&lang=pug"
import script from "./UiZoomImg.vue?vue&type=script&lang=js"
export * from "./UiZoomImg.vue?vue&type=script&lang=js"

import "./UiZoomImg.vue?vue&type=style&index=0&id=42b03333&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b03333"]])

export default __exports__